<form autocomplete="off" class="p-0" novalidate [formGroup]="AttendanceForm">
  <div class="main-content side-content pt-0 ml-0">
    <div class="main-container container-fluid">
      <div class="inner-body">
        <div class="row row-sm add-form">
          <div class="col-lg-12 col-md-12">
            <div class="card custom-card">
              <div class="card-body pb-0">
                <div class="col-md-12 prpl">

                  <!-- Header -->
                  <div class="row align-items-center">
                    <div class="col-md-6 prpl">
                      <div class="d-flex align-items-center">
                        <img alt="Logo" src="../../assets/img/attendance.png" class="mh-45px pb-2">
                        <p class="mb-1">
                          <span class="main-content-label"><b>Attendance Sheets</b></span><br>
                          <span class="text-muted card-sub-title mb-0">
                            List Of Student Attendance
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="col-md-6 d-flex align-items-center justify-content-end">
                      <button type="button"
                              class="btn btn-primary btn-lg px-4"
                              (click)="downloadAttendanceReport()"
                              [disabled]="isDownloading || !isDownloadReady()">
                        <span *ngIf="!isDownloading">
                          <i class="fas fa-download mr-2"></i>
                          Download Report
                        </span>
                        <span *ngIf="isDownloading">
                          <i class="fas fa-spinner fa-spin mr-2"></i>
                          Downloading...
                        </span>
                      </button>
                    </div>
                  </div>

                  <hr class="mt-2">

                  <!-- Filters -->
                  <div class="row clearfix mt-2">

                    <!-- Session -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Session</mat-label>
                          <mat-select #selectSession placeholder="Session" class="colorblack"
                                      formControlName="SessionId">
                            <mat-select-filter *ngIf="selectSession.focused"
                                               [placeholder]="'Filter'"
                                               [displayMember]="'SnName'"
                                               [array]="sessionList"
                                               (filteredReturn)="SessionFilterList = $event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of SessionFilterList"
                                        [value]="item.SnNo"
                                        (click)="getCourse(item)">
                              {{ item.SnName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="AttendanceForm.get('SessionId').hasError('required')">
                            Session is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <!-- Course -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Course</mat-label>
                          <mat-select #selectCourse class="colorblack" formControlName="course">
                            <mat-select-filter *ngIf="selectCourse.focused"
                                               [placeholder]="'Filter'"
                                               [displayMember]="'CoName'"
                                               [array]="CourseList"
                                               (filteredReturn)="filteredListCourse = $event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of filteredListCourse"
                                        [value]="item.CoCode"
                                        (click)="getExamList(item)">
                              {{ item.CoCode }} - {{ item.CoName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="AttendanceForm.get('course').hasError('required')">
                            Course is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <!-- Exam -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Exam</mat-label>
                          <mat-select #selectExam placeholder="Exam" formControlName="EmId">
                            <mat-select-filter *ngIf="selectExam.focused"
                                               [placeholder]="'Filter'"
                                               [displayMember]="'EmName'"
                                               [array]="examList"
                                               (filteredReturn)="filteredListExam = $event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of filteredListExam"
                                        [value]="item.EmId">
                              {{ item.EmCoCode }} - {{ item.EmName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="AttendanceForm.get('EmId').hasError('required')">
                            Exam is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <!-- Branch - Appears conditionally when exam has streams -->
                    <div class="col-sm-3" *ngIf="showBranchField()">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Branch</mat-label>
                          <mat-select #selectBranch placeholder="Branch" class="colorblack"
                                      formControlName="Branch">
                            <mat-select-filter *ngIf="selectBranch.focused"
                                               [placeholder]="'Filter'"
                                               [displayMember]="'StrName'"
                                               [array]="BranchList"
                                               (filteredReturn)="filteredBranchList = $event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of filteredBranchList"
                                        [value]="item.StrId">
                              {{ item.StrCode }} - {{ item.StrName }}
                            </mat-option>
                            <mat-option *ngIf="BranchList.length === 0" disabled>
                              No branches available
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="AttendanceForm.get('Branch').hasError('required')">
                            Branch is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>